// LiveStreamKaraokeItem.js
import { connect } from 'react-redux';

import LiveStreamKaraokeItem from '../component/LiveStreamKaraokeItem.jsx';
import sendLiveStreamGift from '../action/sendLiveStreamGift.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getOperationData from '../selector/getOperationData.js';
import getGiftData from '../selector/getGiftData.js';

const mapStateToProps = (state, { streamId, karaokeId }) => {
  return {
    productId: getLiveStreamData(
      state,
      [streamId, 'karaoke', karaokeId],
      'product_id'
    ),
    title: getLiveStreamData(state, [streamId, 'karaoke', karaokeId], 'title'),
    duration: getLiveStreamData(
      state,
      [streamId, 'karaoke', karaokeId],
      'duration'
    ),
    points: getLiveStreamData(
      state,
      [streamId, 'karaoke', karaokeId],
      'points'
    ),
    imageSource: getGiftData(state, karaokeId, 'image'),
    isFetching: getNetworkingData(
      state,
      ['liveStream', streamId, 'gift', karaokeId],
      'isFetching'
    ),
    giftSendingStatus: getOperationData(
      state,
      ['liveStream', 'gift'],
      'giftSendingStatus'
    ),
  };
};

const mapDispatchToProps = (dispatch, { streamId, karaokeId }) => {
  return {
    sendLiveStreamGift: () =>
      dispatch(sendLiveStreamGift({ streamId, giftId: karaokeId })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamKaraokeItem);
